import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// use as module instead?
export const storeCombos = new Vuex.Store({
    strict: true,
    state: {
        showComboModal: {},
        isLoading: false,
        comboKStrings: null,
        kStrings: null,
        isAppMode: false,
        isDesktop: false,
        couponId: {}, // coupon to be copied
        discount: {},
        discountLabel: {},
        productsData: {}, // ws data, >= 2 products, add both or one by one
        skuList: {}, //add to cart bulk list*/
        quantity: 1, // no mutation
        priceData: {},
        noPreSelection: false, // for cart carousels selected default 
        carouselTypes: ['colorId', 'optionId', 'flavorId'],
        cartNotification: null,
        cartWarning: null,
        mubData: {},
        isBlackRabbit: false
    },
    mutations: {
        comboModal(state, payload) {
            state.showComboModal = Object.assign({}, state.showComboModal, payload);
        },
        isLoading(state, payload) {
            state.isLoading = payload;
        },
        kStrings(state, payload) {
            state.kStrings = Object.assign({}, state.kStrings, payload);
        },
        comboKStrings(state, payload) {
            //state.comboKStrings = Object.assign({}, state.comboKStrings, payload);
            state.comboKStrings = payload;
        },
        isAppMode(state, payload) {
            state.isAppMode = payload;
        },
        isDesktop(state, payload) {
            state.isDesktop = payload;
        },
        couponId(state, payload) {
            state.couponId = Object.assign({}, state.couponId, payload);
        },
        discount(state, payload) {
            state.discount = Object.assign({}, state.discount, payload);
        },
        discountLabel(state, payload) {
            state.discountLabel = Object.assign({}, state.discountLabel, payload);
        },
        productsData(state, payload) {
            state.productsData = Object.assign({}, state.productsData, payload);
        },
        updateSkuList(state, payload) {
            state.skuList = Object.keys(payload).length ? Object.assign({}, state.skuList, payload) : {};
        },
        priceData(state, payload) { // discontinued
            state.priceData = Object.assign({}, state.priceData, payload);
        },
        updateProductsPrice(state, payload) {
            // TODO um reviewzito aqui pls
            //console.log('payload: ', payload);
            //console.log('state combo products: ', state.productsData[payload.comboId]);
            if(payload.comboId && Object.keys(state.productsData[payload.comboId]).length >= 2) {
                Object.keys(state.productsData[payload.comboId]).map((key) => {
                    if (state.productsData[payload.comboId][key].groupId == payload.groupId) {
                        let discount = state.discount[payload.comboId] ?? 0;
                        if(discount && payload.price) {
                            let priceReference = payload.priceCrossed ? payload.priceCrossed : payload.price;
                            let price = priceReference - (priceReference * (discount / 100));
                            state.productsData[payload.comboId][key].price = price
                            state.productsData[payload.comboId][key].priceReference = priceReference;
                        }
                    }
                });
            }
        },
        calcPriceData(state, payload){
            let comboId  = payload.comboId ?? null;
            if(!comboId){
                return;
            }
            let products = state.productsData[payload.comboId] ?? [];
            let price    = 0;
            let priceRef = 0;
            if(comboId && products.length >= 2){
                Object.keys(products).forEach(key => {
                    price    = price + (products[key]?.price ?? 0);
                    priceRef = priceRef + (products[key]?.priceReference ?? 0);
                });
            }
            let hasAppJs = typeof App != 'undefined' && typeof App.js != 'undefined';
            let newObj = {
                price: hasAppJs ? App.js.formatPrice(price) : price.toFixed(2), 
                priceCrossed:  hasAppJs ? App.js.formatPrice(priceRef) : priceRef.toFixed(2)
            };
            state.priceData = {...state.priceData,...{[comboId]: newObj}};
        },
        updateCartNotification(state, payload) {
            state.cartNotification = payload;
            //console.log('notification payload: ', payload);
            //console.log('state notification: ', state.cartNotification);
            let cartItemCount = document.getElementById('cartItemCount');
            let cartIconDiv = document.getElementById('cartIcon');
            let headerImg = document.getElementById('headerImg');
            
            if (state.cartNotification && state.cartNotification.success) {
                if (cartItemCount) {
                    cartItemCount.classList.add('anim-mode');
                }
                if (cartIconDiv) {
                    cartIconDiv.classList.add('anim-mode');
                }
                if(headerImg) {
                    headerImg.classList.add('anim-mode');
                }
                
                setTimeout(() => {
                    setTimeout(() => {
                        state.cartNotification.animationState = 'shrink';
                    }, 200);
                    setTimeout(() => {
                        state.cartNotification.animationState = 'jump';
                    }, 400);
                    setTimeout(() => {
                        //state.cartNotification.animationState = null;
                        state.cartNotification = null;
                        setTimeout(() => {
                            if (cartItemCount) {
                                cartItemCount.classList.remove('anim-mode');
                            }
                            if (cartIconDiv) {
                                cartIconDiv.classList.remove('anim-mode');
                            }
                            if(headerImg) {
                                headerImg.classList.remove('anim-mode');
                            }
                        }, 100);
                    }, 2000);
                }, 500);
            } else {
                setTimeout(() => {
                    state.cartNotification = null;
                }, 1875);
            }
        },
        cartWarning(state, payload) {
            state.cartWarning = payload;
        },       
        mubData(state, payload) {
            state.mubData = Object.assign({}, state.mubData, payload);
        },
        isBlackRabbit(state, payload) {
            state.isBlackRabbit = payload;
        },
    },
    actions: {
        setComboModal(context, payload) {
            context.commit('comboModal', payload);
        },
        setLoading(context, payload) {
            context.commit('isLoading', payload);
        },
        setKStrings(context, payload) {
            context.commit('kStrings', payload);
        },
        setComboKStrings(context, payload) {
            context.commit('comboKStrings', payload);
        },
        isAppMode(context, payload) {
            context.commit('isAppMode', payload);
        },
        isDesktop(context, payload) {
            context.commit('isDesktop', payload);
        },
        addCombo(context, payload) {
            if(!payload){
                return;
            }
            context.commit('comboKStrings', payload.kStrings);
            context.commit('productsData', {[payload.comboId]: payload.products});
            context.commit('couponId', {[payload.comboId]: payload.couponId});
            context.commit('discount', {[payload.comboId]: payload.discount});
            context.commit('discountLabel', {[payload.comboId]: payload.discountLabel});
            context.commit('mubData', {[payload.comboId]: payload.mub});
            context.commit('isBlackRabbit', payload.isBlackRabbit);
            context.commit('isAppMode', payload.isAppStore);
        },
        setSkuList(context, payload) {
            context.commit('updateSkuList', payload);
        },
        setPriceData(context, payload) {
            context.commit('priceData', payload);
        },
        async updateProductsPrice(context, payload) {
            await context.commit('updateProductsPrice', payload);
            context.commit('calcPriceData', payload);
        },
        setCartNotification(state, payload) {
            if(!payload) {
                state.cartNotification = null;
            }
            state.cartNotification =  Object.assign({}, state.cartNotification, payload);
        },
        setCartWarning(context, payload) {
            context.commit('cartWarning', payload);
            setTimeout(() => { // after Xs, resets 
                context.commit('cartWarning', null);
                //console.log('hide toast');
            }, 4000);
        },
        cartItemNumUpdate(context, numItem) {
            let cartItemCountDiv = document.getElementById('cartItemCount');
            if (cartItemCountDiv && (parseInt(numItem)) > 0) {
                App.js.callAppsJs('setCartItem', numItem);
                if(numItem > 99) {
                    numItem = '+99';
                }
                cartItemCountDiv.classList.remove("d-none");
                cartItemCountDiv.innerHTML = numItem;
            }
        },
    },
    getters: {
        showComboModal: state => state.showComboModal,
        isLoading: state => state.isLoading,
        kStrings: state => state.kStrings,
        comboKStrings: state => state.comboKStrings,
        isAppMode: state => state.isAppMode,
        isDesktop: state => state.isDesktop,
        productsData: state => state.productsData,
        couponId: state => state.couponId,
        discount: state => state.discount,
        discountLabel: state => state.discountLabel,
        quantity: state => state.quantity,
        skuList: state => state.skuList,
        priceData: state => state.priceData,
        carouselTypes: state => state.carouselTypes,
        cartNotification: state => state.cartNotification,
        cartWarning: state => state.cartWarning,
        mubData: state => state.mubData,
        isBlackRabbit: state => state.isBlackRabbit,
    },
});